// components/Page.tsx
import * as React from "react";
import { Button, createStyles, Grid, Theme, withStyles } from "@material-ui/core";
import Logo from "./Logo";

const styles = ({ spacing }: Theme) =>
    createStyles({
        root: {
            flexGrow: 1,
            marginLeft: spacing(16),
            marginRight: spacing(16),
        },
        button: {
            width: '100%',
            backgroundColor: 'transparent',
            color: 'black',
            border: '1px solid black',
            padding: '10px',
            margin: '5px 0',
            '&:hover': {
                backgroundColor: 'rgba(0, 0, 0, 0.04)',
            }
        },
    });

const HubsPage = (props: any) => {
    const { classes } = props;
    return (
        <div className={classes.root}>
            <Grid container spacing={3}>
                <Logo />
                <Grid item xs={12}>
                    <Grid container spacing={3} justify="center">
                        <Grid item xs={3}>
                            <Button
                                variant="outlined"
                                className={classes.button}
                                fullWidth
                                href="/tools/hubs/create-patient"
                            >
                                Create HUBS Patient
                            </Button>
                        </Grid>
                        <Grid item xs={3}>
                            <Button
                                variant="outlined"
                                className={classes.button}
                                fullWidth
                                href="/tools/hubs/get-patient"
                            >
                                Get HUBS Patient
                            </Button>
                        </Grid>
                        <Grid item xs={3}>
                            <Button
                                variant="outlined"
                                className={classes.button}
                                fullWidth
                                href="/tools/hubs/get-prescription"
                            >
                                Get HUBS Prescription
                            </Button>
                        </Grid>
                        <Grid item xs={3}>
                            <Button
                                variant="outlined"
                                className={classes.button}
                                fullWidth
                                href="/tools/hubs/get-order"
                            >
                                Get HUBS Order
                            </Button>
                        </Grid>
                        <Grid item xs={3}>
                            <Button
                                variant="outlined"
                                className={classes.button}
                                fullWidth
                                href="/tools/hubs/cancel-order"
                            >
                                Cancel HUBS Order
                            </Button>
                        </Grid>
                        <Grid item xs={3}>
                            <Button
                                variant="outlined"
                                className={classes.button}
                                fullWidth
                                href="/tools/hubs/create-order"
                            >
                                Create HUBS Order
                            </Button>
                        </Grid>
                        <Grid item xs={3}>
                            <Button
                                variant="outlined"
                                className={classes.button}
                                fullWidth
                                href="/tools/hubs/create-payment-instrument"
                            >
                                Create HUBS Payment Instrument
                            </Button>
                        </Grid>
                        <Grid item xs={3}>
                            <Button
                                variant="outlined"
                                className={classes.button}
                                fullWidth
                                href="/tools/hubs/create-prescription"
                            >
                                Create HUBS Prescription
                            </Button>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </div>
    );
};

export default withStyles(styles)(HubsPage);
